import { render, staticRenderFns } from "./milista.vue?vue&type=template&id=2f279a60&"
import script from "./milista.vue?vue&type=script&lang=js&"
export * from "./milista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports